<div
    class="vue-froala"
    :class="{
        'm--is-focus': isFocused,
        'm--is-collapsed': collapsed,
        'm--is-anim-ready': isInitialized,
        'm--is-dirty': isDirty,
        'm--is-readonly' : readonly,
        'm--is-disabled' : disabled
    }"
    :style="{ 'min-height': minHeight }"
    @click="onClick"
    @mousedown.capture="isDirty = !disabled"
    @touchstart.capture="isDirty = !disabled"
>
    <component ref="editor"
               :is="tag"></component>
    <m-file-upload :open.sync="isFileUploadOpen"
                   :max-files="1"
                   :store-name="fileUploadStoreName"
                   :allowed-extensions="imageExtensions"
                   :custom-validation="imageUploadCustomValidation"
                   @files-ready="filesReady"
                   @done="filesAdded"
                   @close="onCloseFileUpload"></m-file-upload>
</div>
